import { yup } from '@framework/validation';
import { IBaseWidget } from '../../schema/widgets/IBaseWidget';
import { hasCode } from '../../schema/widgets/ICodeWidget';
import { IWidgetOptionValue, Widget } from '../../schema/widgets/Widget';
import { parseAdvancedRichTextToString } from './parseAdvancedRichTextToString';

/**
 * Imposta la label del widget in base al contenuto HTML.
 */
export function setWidgetSchemaLabel(widget: Widget, schema: yup.AnySchema) {
  // Se la label è già stata impostata, non la sovrascrivo
  if (schema.spec.label) return schema;
  const codeLabel = hasCode(widget) ? widget.code : '';
  return setInternalSchemaLabel(widget, codeLabel, schema);
}

/**
 * Imposta la label dell'opzione in base al contenuto HTML.
 */
export function setWidgetOptionSchemaLabel<T extends yup.AnySchema>(
  option: IWidgetOptionValue,
  schema: T,
) {
  return setInternalSchemaLabel(option, option.value, schema) as T;
}

function setInternalSchemaLabel(
  item: IBaseWidget | IWidgetOptionValue,
  defaultLabel: string,
  schema: yup.AnySchema,
) {
  const label = getWidgetLabel(item);
  const labelText = parseAdvancedRichTextToString(label);

  return schema.label(labelText || defaultLabel);
}

/**
 * Ritorna la label solamente se esiste.
 */
function getWidgetLabel(widget: IBaseWidget | IWidgetOptionValue) {
  if (
    !('label' in widget) ||
    !widget.label ||
    widget.label.length === 0 ||
    !widget.label[0].text
  ) {
    return null;
  }

  return widget.label;
}
